__webpack_require__.p = "/binding-energy/";